export enum DealPaymentStatusEnum {
  paid = 'paid',
  due = 'due',
  overdue = 'overdue',
  // `booked` is a client-only toggle mode (show booked total instead of the closed split);
  // it is stripped in filtersToDto and never sent to the API.
  booked = 'booked',
}
